import { EAgentKeys, TAgent } from '~/features/agents/models'
import { EClientPath } from '~/models/api'
import pathBuilder from '~/utils/api'

export type TGetChatUrlProps = {
  agentChatFriendlyUrl: TAgent[EAgentKeys.chatFriendlyUrl]
  agentId: TAgent[EAgentKeys.id]
}

export const getChatUrl = ({
  agentChatFriendlyUrl,
  agentId,
}: TGetChatUrlProps) => {
  let base =
    (window as typeof window & { baseurl?: string }).baseurl ||
    window.location.host

  if (base.endsWith('/')) {
    base = base.slice(0, -1)
  }

  if (agentChatFriendlyUrl) {
    return `${base}/${agentChatFriendlyUrl}`
  }

  return `${base}${pathBuilder(EClientPath.chat, { agentId })}`
}
